export const download = (file: Blob, filename: string) => {
    const csvURL = window.URL.createObjectURL(file);
    const tempLink = document.createElement('a');
    tempLink.href = csvURL;
    tempLink.setAttribute('download', filename);
    tempLink.click();

    tempLink.remove();
};
